import { render, staticRenderFns } from "./BookCreate.vue?vue&type=template&id=acb162c4"
import script from "../../controllers/book_library/book-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/book_library/book-create.js?vue&type=script&lang=js&external"
import style0 from "./BookCreate.vue?vue&type=style&index=0&id=acb162c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports